export default {
  tabs: {
    access: 'Accès',
    notification_preferences: 'Préférences de notifications',
  },
  sections: {
    notification_preferences: {
      title: 'Préférences de notifications',
      form: {
        has_voice_call_reminders: {
          label: 'Recevoir des appels automatisés pour les commandes en attente',
        },
        voice_reminders_phone_number: {
          label: 'Numéro de téléphone pour recevoir des appels',
        },
        has_whatsapp_notifications: {
          label: 'Envoyer des notifications (ex. : commandes en pause) via WhatsApp',
        },
        whatsapp_phone_number: {
          label: 'Numéro WhatsApp',
        },
        has_order_email_notifications: {
          label: 'Envoyer les notifications de commande par e-mail',
        },
        order_notifications_email: {
          label: 'Adresse e-mail pour transférer les notifications de commande',
        },
      },
    },
    voice_calls: {
      title: 'Appels vocaux',
    },
    whats_app_notifications: {
      title: 'Notifications WhatsApp',
    },
    order_email_notifications: {
      title: 'Notifications de commande par e-mail',
    },
    access_control: {
      title: "Contrôle d'accès",
      form: {
        company_ids: {
          label: 'Peut accéder aux restaurants',
          tooltip: 'Donne accès aux restaurants suivants (en plus des restaurants de la même marque)',
        },
      },
    },
  },
  buttons: {
    save: 'Enregistrer',
  },
  toasts: {
    failed_to_save_changes: "Impossible d'enregistrer les modifications",
    changes_got_saved: 'Modifications enregistrées',
  },
};
